import React, { Component } from 'react';
import { Row, Col, Popconfirm } from 'antd';
import Card2 from '../../components/Card2';
import SelectPlayers from '../../components/SelectPlayers';
import { api, app } from "../../app";

class SignWhiteList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            rights: app.getData('rights'),
            loading: true,
        };
    }

    setData = async (data) => {
        await app.setStateSync(this, data);
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.dataSource();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 列表数据
     */
    dataSource = async () => {
        await this.setState({ loading: true });
        let params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let { flag, data, msg } = await app.post(api.SinginDataNationwideList, params);
        if (flag === 1) {
            await this.setState({ dataList: data, loading: false });
        } else {
            await this.setState({ loading: false });
            app.alert(msg, "error");
        }
    }

    /**
     * 删除发布人员
     * @param type
     */
    handleDetele = async (id) => {
        let params = {
            id,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let { flag, msg } = await app.post(api.SinginDataNationwideListDelete, params);
        if (flag === 1) {
            app.alert("删除成功", "success");
            await this.dataSource();
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 添加
     * @param res
     * @returns {Promise<void>}
     */
    handleAdd = async ({ user }) => {
        // console.log(user);
        let param = {
            user,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let { flag, msg } = await app.post(api.SinginDataNationwideListAdd, param);
        if (flag === 1) {
            app.alert("添加成功", "success");
            this.dataSource();
            await this.setData({ add_visible: false });
            return Promise.resolve(true);
        } else {
            app.alert(msg, "warn");
            return Promise.resolve(false);
        }
    }

    /**
     * 打开添加弹框
     * @returns {Promise<void>}
     * @constructor
     */
    OpenAddModal = async () => {
        await this.setData({ add_visible: true });
    }

    render() {
        let { dataList, rights, add_visible } = this.state,
            columns = [
                {
                    name: "姓名",
                    span: 5,
                    key: "vname",
                },
                {
                    name: "所属队伍",
                    span: 9,
                    key: "teamname",
                },
                {
                    name: "职位",
                    span: 5,
                    key: "teampositionname",
                    default: "暂无",
                },
                {
                    name: "操作",
                    span: 5,
                    render: (val, record) => {
                        return (
                            <Popconfirm title="确认删除吗？" onConfirm={() => this.handleDetele(record.id)} okText="是"
                                cancelText="否">
                                <a href="#" className="link">删除</a>
                            </Popconfirm>
                        )
                    }
                }
            ],
            sp = {
                rights,
                visible: add_visible,
                provinceApi: api.MProvinceList,
                teamApi: api.provinceTeamListAll,
                playerApi: api.GetTeamUserAllAdmid,
                success: this.handleAdd,
            };
        return (
            <div className="page sign-whitelist">
                <div className="page-title">查看签到白名单</div>
                <div className="page-content">
                    <Card2 style={{ width: '80%' }} title="查看签到白名单" titleLink="添加查看人员" data={dataList} columns={columns}
                        titleLinkClick={() => this.OpenAddModal()} actionEvent={this.handleDetele} />
                    <SelectPlayers {...sp} />
                </div>
            </div>
        );
    }
}

export default SignWhiteList;



// WEBPACK FOOTER //
// ./src/routes/bigData/SignWhiteList.jsx